import reframe from 'reframe.js';
import smoothscroll from 'smoothscroll-polyfill';

/* ========================================================================
 * Mobile Menu Toggle
 * ======================================================================== */

var mobileMenuToggle = function () {
  var $menuButton = $('.site-header__menu-button');
  var $siteHeader = $('.site-header');

  $menuButton.on('click', function (e) {
    e.preventDefault();
    $siteHeader.toggleClass('active');
  });
};

/* ========================================================================
 * Mobile Submenu Toggle
 * ======================================================================== */

var mobileSubmenuToggle = function() {
  var $menuItemHasChildren = $('.menu-item-has-children');

  $menuItemHasChildren.on('click', function () {
    $(this).find('.submenu').focus();
  });
};

/* ========================================================================
* Smooth Scroll to Anchor
* ======================================================================== */

  var smoothScrollToAnchor = function () {
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top,
            }, 500, function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(':focus')) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            });
          }
        }
      });
  };

export default {
  init() {
    mobileMenuToggle();
    mobileSubmenuToggle();
    smoothScrollToAnchor();
    reframe('iframe[src^="https://www.youtube.com/embed/"]');
    smoothscroll.polyfill();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js